import { FunctionComponent, ReactNode } from "react";
import { observer } from "mobx-react-lite";

import { Sidebar } from "primereact/sidebar";

import { useStore } from "../../../../stores/StoreContext";

import "./OverlaySidebar.scss";

interface IOverlaySidebarProps {
  children: string | ReactNode | ReactNode[];
}

const RawOverlaySidebarComponent: FunctionComponent<IOverlaySidebarProps> = ({ children }: IOverlaySidebarProps) => {
  const { sidebarStore } = useStore();

  return (
    <Sidebar
      className="sidebar-overlay"
      visible={sidebarStore.isOverlaySidebarVisible}
      onHide={() => sidebarStore.setOverlaySidebarVisible(false)}
    >
      {children}
    </Sidebar>
  );
};

export const OverlaySidebarComponent = observer(RawOverlaySidebarComponent);
